import { render, staticRenderFns } from "./ArticleQueue.vue?vue&type=template&id=61f4328f&scoped=true"
import script from "./ArticleQueue.vue?vue&type=script&lang=js"
export * from "./ArticleQueue.vue?vue&type=script&lang=js"
import style0 from "./ArticleQueue.vue?vue&type=style&index=0&id=61f4328f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f4328f",
  null
  
)

export default component.exports